export default "__VITE_ASSET__DxLZnKHM__"